import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {

  constructor(private apiService: ApiService) { }

  /**
   * Get permissions for a specific user
   * URL: user-access/{id}
   */
  getUserAccess(userId: number): Observable<any> {
    return this.apiService.get('user-access/' + userId);
  }

  /**
   * Get permissions for the logged-in user
   * URL: user-access/me
   */
  getMyAccess(): Observable<any> {
    return this.apiService.get('user-access/me');
  }

  /**
   * Save permissions
   * URL: user-access/save
   */
  saveUserAccess(data: any): Observable<any> {
    return this.apiService.post('user-access/save', data);
  }

  /**
   * Check if user has specific access (update/delete) for a path
   */
  async hasAccess(path: string, action: 'update' | 'delete'): Promise<boolean> {
    return new Promise((resolve) => {
      this.getMyAccess().subscribe({
        next: (res: any) => {
          const data = res.data;
          // If no data (owner or error), default to true for backward compatibility or owner
          if (!data || !data.user_id) return resolve(true); 
          
          const list = action === 'update' ? data.update_access : data.delete_access;
          resolve(list?.includes(path) || false);
        },
        error: () => resolve(false)
      });
    });
  }
}